<template>
  <v-layout>
    <v-btn
      color="primary"
      small
      :disabled="!hasPrev || value == 1"
      depressed
      fab
      class="my-0"
      :loading="loading"
      @click="onChangePage('prev', $event)"
      ><v-icon>arrow_back_ios</v-icon></v-btn
    >
    <div class="form-control">
      <input
        id="inputPage"
        type="number"
        :value="value"
        :disabled="loading"
        style="width: 50px; text-align: center; padding: 5px"
        @keyup.enter="onChangePage('blur', $event)"
        @blur="onChangePage('blur', $event)"
        @input="onInput"
      />
      / {{ pagelength }}
    </div>
    <v-btn
      color="primary"
      small
      :disabled="!hasNext || value == pagelength"
      depressed
      fab
      class="my-0"
      :loading="loading"
      @click="onChangePage('next', $event)"
      ><v-icon>arrow_forward_ios</v-icon></v-btn
    >
  </v-layout>
</template>

<script>
export default {
  props: {
    value: {
      default: 1
    },
    hasNext: {
      default: false
    },
    pagelength: { default: 1 },
    hasPrev: {
      default: false
    },
    loading: {
      default: false
    }
  },
  data() {
    return {
      isRendering: false
    }
  },
  methods: {
    onChangePage(type, event) {
      let _value = this.value
      if (!this.value || this.value === 0) {
        const inputPage = document.getElementById('inputPage')
        this.$emit('input', 1)
        _value = 1
        if (inputPage) {
          inputPage.value = 1
        }
      }
      let page = _value
      let newpage = _value
      let isPass = true
      switch (type) {
        case 'prev':
          newpage = newpage - 1
          break
        case 'blur':
          try {
            newpage = parseInt(event.target.value)
          } catch (error) {
            isPass = false
            event.target.value = page
          }
          break
        case 'next':
          newpage = newpage + 1
          break

        default:
          break
      }
      if (!isPass) return false

      const vm = this
      this.$emit('onChangePage', {
        currentpage: page,
        newpage: newpage,
        onchange: function (newpage) {
          vm.$emit('input', newpage)
        }
      })
    },
    onInput(e) {
      if (!e) return
      const value = e.target.value
      const inputPage = document.getElementById('inputPage')

      if (!value) {
        this.$emit('input', null)
        if (inputPage) {
          inputPage.value = null
        }
      } else {
        this.$emit('input', Math.abs(Number(value)))
        if (inputPage) {
          inputPage.value = Math.abs(Number(value))
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}
</style>



// WEBPACK FOOTER //
// src/components/elements/CustomPaginate.vue